// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ntvS","requiredAsterisk":"Info_requiredAsterisk__1AWK_"};